import axios from 'axios';
import { from } from 'rxjs';

import { createCancelablePromise } from '../../services/promises/create-cancelable-promise';
import { PAGE_SIZE_250, FIRST_PAGE } from '../../services/pagination-service';

export const getFulfillments = ({
  pageNumber = FIRST_PAGE,
  pageSize = PAGE_SIZE_250,
  orderBy = 'CreateDateTime',
  direction = 'Ascending',
  filters = {},
  searchTerm,
}) => {
  const params = {
    page: {
      pageNumber,
      pageSize,
    },
    orderBy,
    orderByDirection: direction,
    searchTerm,
  };
  const getAndTransform = axios
    .post('/fulfillmentGrid', {
      ...params,
      filter: filters,
    })
    .then(({ data }) => {
      return data;
    });

  return createCancelablePromise(getAndTransform);
};

export const cancelFulfillments = (fulfillmentPlanIds) => {
  return axios.post('/fulfillment/cancelExternalFulfillments', fulfillmentPlanIds);
};

export const updateFulfillmentStatuses = (fulfillmentIds) => {
  return axios.post('/fulfillment/updateStatus', {
    fulfillmentIds,
  });
};

export const exportFulfillments = (fulfillmentIds, filter) => {
  const request = axios
    .post('/fulfillment/exportExternalFulfillments', {
      fulfillmentIds,
      filter,
    })
    .then((resp) => resp.data);

  return from(request);
};

export const exportFulfillmentsExtended = (requestUrl, requestBody) => {
  const request = axios.post(requestUrl, requestBody).then((resp) => resp.data);
  return from(request);
};

export const customExportFulfillments = (requestBody, requestUrl = undefined) => {
  const url = requestUrl || 'seller/customextracts/exportFulfillments';
  const request = axios.post(url, requestBody).then((resp) => resp.data);
  return from(request);
};
